import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=2bc4b132&scoped=true"
import script from "./menu.js?vue&type=script&lang=js&external"
export * from "./menu.js?vue&type=script&lang=js&external"
import style0 from "../admin.scss?vue&type=style&index=0&id=2bc4b132&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4b132",
  null
  
)

export default component.exports